var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1328_6796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 20.9751C6.95325 20.9751 3 17.0219 3 11.9751C3.30632 0.0400515 20.6953 0.0428634 21 11.9752C21 17.0219 17.0468 20.9751 12 20.9751ZM12 3.74854C7.38697 3.74854 3.77344 7.36208 3.77344 11.9751C4.05346 22.8845 19.9481 22.8819 20.2266 11.975C20.2266 7.36208 16.613 3.74854 12 3.74854Z",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5469 11.9751L15.3703 9.15167C15.5214 9.00064 15.5214 8.75578 15.3703 8.60475C15.2193 8.45375 14.9745 8.45375 14.8234 8.60475L12 11.4282L9.17656 8.60475C9.02549 8.45375 8.7807 8.45375 8.62963 8.60475C8.4786 8.75578 8.4786 9.00064 8.62963 9.15167L11.4531 11.9751L8.62963 14.7985C8.4786 14.9495 8.4786 15.1944 8.62963 15.3454C8.7807 15.4964 9.02549 15.4964 9.17656 15.3454L12 12.522L14.8234 15.3455C14.9745 15.4965 15.2192 15.4965 15.3703 15.3455C15.5213 15.1944 15.5213 14.9496 15.3703 14.7985L12.5469 11.9751Z",
    fill: "#464646"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1328_6796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.67e4dc9891cc4a0ab4865a8d421e6216.svg";
export { ForwardRef as ReactComponent };